import { fetcher, fetcherWithToken } from '@/shared/api/fetcher';

type PhConfirmPhoneParams = {
  phone: string;
  isLegalAge: boolean;
  turnstile?: string;
};

type PhConfirmPhoneResponse = {
  retryAfter: number;
  turnstile: boolean;
};

type PhRegisterPayload = {
  phone: string;
  email?: string;
  password?: string;
  sms?: string;
  turnstile?: string;
  isLegalAge?: boolean;
  isPagcorAdult?: boolean;
  isPagcorNotOfficial?: boolean;
  isPagcorNotGelHolder?: boolean;
  entryURL?: string;
  referer?: string;
  lang?: string;
  currency?: string;
  welcomeBonus?: boolean;
  promocode?: string;
  isNews?: boolean;
  outlet?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  birthdate?: string;
};

type PhLoginResponse = {
  token: string;
  expired: number;
};

type PhOutlet = {
  key: string;
  val: string;
};

type RegisterFlow = 'full' | 'short';

type PhSettingsResponse = {
  registerFlow: RegisterFlow;
  outlet: PhOutlet[];
  crypto?: boolean;
  fillOut?: boolean;
};

const PH_REGISTER_ENDPOINT = '/register';
const PH_LOGIN_ENDPOINT = '/login';
const PH_CONFIRM_PHONE_ENDPOINT = '/confirm/phone';
const PH_SETTINGS_ENDPOINT = '/settings';

const normalizeConfirmPhoneResponse = (
  response: Partial<PhConfirmPhoneResponse>
): PhConfirmPhoneResponse => ({
  retryAfter: Number(response.retryAfter ?? 0),
  turnstile: response.turnstile === true,
});

export const confirmPhPhone = async (
  params: PhConfirmPhoneParams
): Promise<PhConfirmPhoneResponse> => {
  const query = new URLSearchParams({
    phone: params.phone,
    isLegalAge: String(params.isLegalAge),
  });

  if (params.turnstile) {
    query.set('turnstile', params.turnstile);
  }

  const response = await fetcherWithToken(
    `${PH_CONFIRM_PHONE_ENDPOINT}?${query.toString()}`
  );

  return normalizeConfirmPhoneResponse(response);
};

export const registerPhAuth = (
  payload: PhRegisterPayload
): Promise<PhLoginResponse> =>
  fetcher(PH_REGISTER_ENDPOINT, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const loginPhAuth = (
  payload: PhRegisterPayload
): Promise<PhLoginResponse> =>
  fetcher(PH_LOGIN_ENDPOINT, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const getPhSettings = (): Promise<PhSettingsResponse> =>
  fetcher(PH_SETTINGS_ENDPOINT);

export type { PhOutlet };
